"use strict";
// https://github.com/ChainAgnostic/CAIPs/blob/master/CAIPs/caip-2.md
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCAIP2 = exports.toCAIP2 = exports.chainNamespaceToChainType = exports.networkTypeToChainReference = exports.chainReferenceToNetworkType = exports.isChainId = exports.fromChainId = exports.toChainId = exports.CHAIN_REFERENCE = exports.CHAIN_NAMESPACE = void 0;
const types_1 = require("@shapeshiftoss/types");
const invert_1 = __importDefault(require("lodash/invert"));
exports.CHAIN_NAMESPACE = {
    Ethereum: 'eip155',
    Bitcoin: 'bip122',
    Cosmos: 'cosmos'
};
exports.CHAIN_REFERENCE = {
    EthereumMainnet: '1',
    EthereumRopsten: '3',
    EthereumRinkeby: '4',
    // EthereumKovan: '42', // currently unsupported by ShapeShift
    // https://github.com/bitcoin/bips/blob/master/bip-0122.mediawiki#definition-of-chain-id
    // chainId uses max length of 32 chars of the genesis block
    BitcoinMainnet: '000000000019d6689c085ae165831e93',
    BitcoinTestnet: '000000000933ea01ad0ee984209779ba',
    CosmosHubMainnet: 'cosmoshub-4',
    CosmosHubVega: 'vega-testnet',
    OsmosisMainnet: 'osmosis-1',
    OsmosisTestnet: 'osmo-testnet-1'
};
const shapeShiftToChainId = Object.freeze({
    [types_1.ChainTypes.Ethereum]: {
        namespace: exports.CHAIN_NAMESPACE.Ethereum,
        reference: {
            [types_1.NetworkTypes.MAINNET]: exports.CHAIN_REFERENCE.EthereumMainnet,
            [types_1.NetworkTypes.ETH_ROPSTEN]: exports.CHAIN_REFERENCE.EthereumRopsten,
            [types_1.NetworkTypes.ETH_RINKEBY]: exports.CHAIN_REFERENCE.EthereumRinkeby
        }
    },
    [types_1.ChainTypes.Bitcoin]: {
        namespace: exports.CHAIN_NAMESPACE.Bitcoin,
        reference: {
            [types_1.NetworkTypes.MAINNET]: exports.CHAIN_REFERENCE.BitcoinMainnet,
            [types_1.NetworkTypes.TESTNET]: exports.CHAIN_REFERENCE.BitcoinTestnet
        }
    },
    [types_1.ChainTypes.Cosmos]: {
        namespace: exports.CHAIN_NAMESPACE.Cosmos,
        reference: {
            [types_1.NetworkTypes.COSMOSHUB_MAINNET]: exports.CHAIN_REFERENCE.CosmosHubMainnet,
            [types_1.NetworkTypes.COSMOSHUB_VEGA]: exports.CHAIN_REFERENCE.CosmosHubVega
        }
    },
    [types_1.ChainTypes.Osmosis]: {
        namespace: exports.CHAIN_NAMESPACE.Cosmos,
        reference: {
            [types_1.NetworkTypes.OSMOSIS_MAINNET]: exports.CHAIN_REFERENCE.OsmosisMainnet,
            [types_1.NetworkTypes.OSMOSIS_TESTNET]: exports.CHAIN_REFERENCE.OsmosisTestnet
        }
    }
});
const toChainId = (args) => {
    const { chain, network } = args;
    const namespace = shapeShiftToChainId[chain].namespace;
    switch (chain) {
        case types_1.ChainTypes.Ethereum: {
            const referenceMap = shapeShiftToChainId[chain].reference;
            switch (network) {
                case types_1.NetworkTypes.MAINNET:
                case types_1.NetworkTypes.ETH_ROPSTEN:
                case types_1.NetworkTypes.ETH_RINKEBY: {
                    const reference = referenceMap[network];
                    return `${namespace}:${reference}`;
                }
            }
            break;
        }
        case types_1.ChainTypes.Bitcoin: {
            const referenceMap = shapeShiftToChainId[chain].reference;
            switch (network) {
                case types_1.NetworkTypes.MAINNET:
                case types_1.NetworkTypes.TESTNET: {
                    const reference = referenceMap[network];
                    return `${namespace}:${reference}`;
                }
            }
            break;
        }
        case types_1.ChainTypes.Cosmos: {
            const referenceMap = shapeShiftToChainId[chain].reference;
            switch (network) {
                case types_1.NetworkTypes.COSMOSHUB_MAINNET:
                case types_1.NetworkTypes.COSMOSHUB_VEGA: {
                    const reference = referenceMap[network];
                    return `${namespace}:${reference}`;
                }
            }
            break;
        }
        case types_1.ChainTypes.Osmosis: {
            const referenceMap = shapeShiftToChainId[chain].reference;
            switch (network) {
                case types_1.NetworkTypes.OSMOSIS_MAINNET:
                case types_1.NetworkTypes.OSMOSIS_TESTNET: {
                    const reference = referenceMap[network];
                    return `${namespace}:${reference}`;
                }
            }
            break;
        }
    }
    throw new Error(`toChainId: unsupported ${chain} network: ${network}`);
};
exports.toChainId = toChainId;
const fromChainId = (chainId) => {
    const [c, n] = chainId.split(':');
    if (!(c && n)) {
        throw new Error(`fromChainId: error parsing chainId, chain: ${c}, network: ${n}`);
    }
    switch (c) {
        case exports.CHAIN_NAMESPACE.Cosmos: {
            switch (n) {
                case exports.CHAIN_REFERENCE.CosmosHubMainnet: {
                    return { chain: types_1.ChainTypes.Cosmos, network: types_1.NetworkTypes.COSMOSHUB_MAINNET };
                }
                case exports.CHAIN_REFERENCE.CosmosHubVega: {
                    return { chain: types_1.ChainTypes.Cosmos, network: types_1.NetworkTypes.COSMOSHUB_VEGA };
                }
                case exports.CHAIN_REFERENCE.OsmosisMainnet: {
                    return { chain: types_1.ChainTypes.Osmosis, network: types_1.NetworkTypes.OSMOSIS_MAINNET };
                }
                case exports.CHAIN_REFERENCE.OsmosisTestnet: {
                    return { chain: types_1.ChainTypes.Osmosis, network: types_1.NetworkTypes.OSMOSIS_TESTNET };
                }
                default: {
                    throw new Error(`fromChainId: unsupported ${c} network: ${n}`);
                }
            }
        }
        case exports.CHAIN_NAMESPACE.Ethereum: {
            const chain = types_1.ChainTypes.Ethereum;
            switch (n) {
                case exports.CHAIN_REFERENCE.EthereumMainnet: {
                    const network = types_1.NetworkTypes.MAINNET;
                    return { chain, network };
                }
                case exports.CHAIN_REFERENCE.EthereumRopsten: {
                    const network = types_1.NetworkTypes.ETH_ROPSTEN;
                    return { chain, network };
                }
                case exports.CHAIN_REFERENCE.EthereumRinkeby: {
                    const network = types_1.NetworkTypes.ETH_RINKEBY;
                    return { chain, network };
                }
                default: {
                    throw new Error(`fromChainId: unsupported ${c} network: ${n}`);
                }
            }
        }
        case exports.CHAIN_NAMESPACE.Bitcoin: {
            const chain = types_1.ChainTypes.Bitcoin;
            switch (n) {
                case exports.CHAIN_REFERENCE.BitcoinMainnet: {
                    const network = types_1.NetworkTypes.MAINNET;
                    return { chain, network };
                }
                case exports.CHAIN_REFERENCE.BitcoinTestnet: {
                    const network = types_1.NetworkTypes.TESTNET;
                    return { chain, network };
                }
                default: {
                    throw new Error(`fromChainId: unsupported ${c} network: ${n}`);
                }
            }
        }
    }
    throw new Error(`fromChainId: unsupported chain: ${c}`);
};
exports.fromChainId = fromChainId;
const isChainId = (chainId) => {
    const [c, n] = chainId.split(':');
    if (!(c && n)) {
        throw new Error(`isChainId: error parsing chainId, chain: ${c}, network: ${n}`);
    }
    switch (c) {
        case exports.CHAIN_NAMESPACE.Cosmos: {
            switch (n) {
                case exports.CHAIN_REFERENCE.CosmosHubMainnet:
                case exports.CHAIN_REFERENCE.CosmosHubVega:
                case exports.CHAIN_REFERENCE.OsmosisMainnet:
                case exports.CHAIN_REFERENCE.OsmosisTestnet:
                    return true;
            }
            break;
        }
        case exports.CHAIN_NAMESPACE.Ethereum: {
            switch (n) {
                case exports.CHAIN_REFERENCE.EthereumMainnet:
                case exports.CHAIN_REFERENCE.EthereumRopsten:
                case exports.CHAIN_REFERENCE.EthereumRinkeby:
                    return true;
            }
            break;
        }
        case exports.CHAIN_NAMESPACE.Bitcoin: {
            switch (n) {
                case exports.CHAIN_REFERENCE.BitcoinMainnet:
                case exports.CHAIN_REFERENCE.BitcoinTestnet:
                    return true;
            }
            break;
        }
    }
    throw new Error(`isChainId: invalid ChainId ${chainId}`);
};
exports.isChainId = isChainId;
exports.chainReferenceToNetworkType = Object.freeze({
    [exports.CHAIN_REFERENCE.BitcoinMainnet]: types_1.NetworkTypes.MAINNET,
    [exports.CHAIN_REFERENCE.BitcoinTestnet]: types_1.NetworkTypes.TESTNET,
    [exports.CHAIN_REFERENCE.EthereumMainnet]: types_1.NetworkTypes.MAINNET,
    [exports.CHAIN_REFERENCE.EthereumRopsten]: types_1.NetworkTypes.ETH_ROPSTEN,
    [exports.CHAIN_REFERENCE.EthereumRinkeby]: types_1.NetworkTypes.ETH_RINKEBY,
    [exports.CHAIN_REFERENCE.CosmosHubMainnet]: types_1.NetworkTypes.COSMOSHUB_MAINNET,
    [exports.CHAIN_REFERENCE.CosmosHubVega]: types_1.NetworkTypes.COSMOSHUB_VEGA,
    [exports.CHAIN_REFERENCE.OsmosisMainnet]: types_1.NetworkTypes.OSMOSIS_MAINNET,
    [exports.CHAIN_REFERENCE.OsmosisTestnet]: types_1.NetworkTypes.OSMOSIS_TESTNET
});
exports.networkTypeToChainReference = (0, invert_1.default)(exports.chainReferenceToNetworkType);
exports.chainNamespaceToChainType = Object.freeze({
    [exports.CHAIN_NAMESPACE.Bitcoin]: types_1.ChainTypes.Bitcoin,
    [exports.CHAIN_NAMESPACE.Ethereum]: types_1.ChainTypes.Ethereum,
    [exports.CHAIN_NAMESPACE.Cosmos]: types_1.ChainTypes.Cosmos
});
exports.toCAIP2 = exports.toChainId;
exports.fromCAIP2 = exports.fromChainId;
